<template>
  <div class="addressform" :class="theme_type">
    <div class="addressform_title">
      <span v-if="update" >{{$t('account.edit_address')}}</span>
      <span v-else >{{$t('account.add_new_address')}}</span>
    </div>
    <div class="addressform_body">
      <div class="row">
        <div class="col-sm-12" >
          <div class="form_item_lable text-uppercase">{{$t('account.first_name')}}</div>
          <input class="page_text_font" type="text" v-model="address.first_name" id="first_name" @blur="required" />
          <div v-if="error.first_name" class="error ">{{error.first_name[0]}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 ">
          <div class="form_item_lable text-uppercase">{{$t('account.last_name')}}</div>
          <input type="text" class="page_text_font" v-model="address.last_name" id="last_name" @blur="required" />
          <div v-if="error.last_name" class="error ">{{error.last_name[0]}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 ">
          <div class="form_item_lable text-uppercase">{{$t('account.company')}}</div>
          <input type="text"  class="page_text_font" v-model="address.company" />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12  ">
          <div class="form_item_lable text-uppercase">{{$t('account.address1')}}</div>
          <input type="text" class="page_text_font" v-model="address.address_1" id="address_1" @blur="required"
          />
          <div v-if="error.address_1" class="error ">{{error.address_1[0]}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 ">
          <div class="form_item_lable text-uppercase">{{$t('account.address2')}}</div>
          <input type="text" class="page_text_font" v-model="address.address_2" />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 ">
          <div class="form_item_lable text-uppercase">{{$t('account.city')}}</div>
          <input type="text" class="page_text_font" v-model="address.city" id="city" @blur="required" />
          <div v-if="error.city" class="error ">{{error.city[0]}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 ">
          <div class="form_item_lable text-uppercase">{{$t('account.country')}}</div>
          <select class="page_text_font" name v-model="address.country" id="country" @blur="required" @change="changecountry">
            <option v-for="item in service" :key="item.code" :value="item.code" v-html="item.name"></option>
          </select>
          <div v-if="error.country" class="error ">{{error.country[0]}}</div>
        </div>
      </div>
      <div class="row" v-show="province.length">
        <div class="col-sm-12 ">
          <div class="form_item_lable text-uppercase">{{$t('account.province')}}</div>
          <select class="page_text_font" name id v-model="address.state">
            <option v-for="item in province" :key="item.code" :value="item.code" v-html="item.name"></option>
          </select>
          <div v-if="error.state" class="error ">{{error.state[0]}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 ">
          <div class="form_item_lable text-uppercase">{{$t('account.postcode')}}</div>
          <input class="page_text_font" type="text" v-model="address.postcode" />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 ">
          <div class="form_item_lable text-uppercase">{{$t('account.phone')}}</div>
          <input type="text" class="page_text_font" v-model="address.phone" />
        </div>
      </div>
    </div>
    
    <div class="addressform_default" style="padding-bottom:15px">
      <input type="checkbox" class="setdefaultbox page_text_font" v-model="address.default" />
      <div class="set_default">{{$t('account.set_default_address')}}</div>
    </div>

    <div class="col-sm-12 showtime_button" >
      <el-button v-if="update" @click="updateaddress" :loading="loading" class="main_button text-center">
        <span v-show="!loading" class="text-uppercase">{{toupdate == 'UPDATE ADDRESS' ? $t('account.edit_address') : toupdate}}</span>
      </el-button>
      <el-button @click="setaddress" :loading="loading" v-else class="main_button text-center">
        <span v-show="!loading" class="text-uppercase">{{toadd == 'ADD ADDRESS' ? $t('account.add_address') : toadd}}</span>
      </el-button>
      <a  href="#" @click="hiddenform">{{$t('account.cancel')}}</a>
    </div>

  </div>
</template>
<script>
// import API from "../../../../../js/API.js";
export default {
  props: ["update", "service", "address_list", "theme_type"],
  data() {
    return {
      loading: false,
      toupdate: "UPDATE ADDRESS",
      toadd: "ADD ADDRESS",
      province: [],
      address: {
        first_name: "",
        last_name: "",
        company: null,
        city: "",
        country: this.$store.state.country,
        state: null,
        postcode: null,
        address_1: "",
        address_2: null,
        phone: null,
        default: false
      },
      error: {
        address_1: "",
        city: "",
        country: "",
        first_name: "",
        last_name: ""
      }
    };
  },
  methods: {
    required(e) {
      if (e.target.value.trim() == "") {
        switch (e.target.id) {
          case "address_1":
          case "city":
          case "country":
          case "first_name":
          case "last_name":
            this.error[e.target.id] = [this.$t("account.field_required")];
            break;
          default:
            break;
        }
      } else {
        switch (e.target.id) {
          case "address_1":
          case "city":
          case "country":
          case "first_name":
          case "last_name":
            this.error[e.target.id] = "";
            break;
          default:
            break;
        }
      }
    },
    hiddenform() {
      this.$emit("hiddenform");
    },
    changecountry(e) {
      this.address.state = null;
      this.province = this.service[e.target.selectedIndex].states;
      if (this.province.length) {
        this.address.state = this.province[0].code;
      }
    },
    yanzheng() {
      let value = true;
      console.log(this.address_list);
      this.address_list.some(item => {
        console.log("asdfasf", item, this.address);
        if (
          item.first_name == this.address.first_name &&
          item.last_name == this.address.last_name &&
          item.company == this.address.company &&
          item.city == this.address.city &&
          item.country == this.address.country &&
          item.state == this.address.state &&
          item.postcode == this.address.postcode &&
          item.address_1 == this.address.address_1 &&
          item.address_2 == this.address.address_2 &&
          item.phone == this.address.phone &&
          (!this.update || item.default == this.address.default)
        ) {
          if (this.update) {
            let update = JSON.stringify(this.update);
            this.address = JSON.parse(update);
          }
          this.$emit("hiddenform");
          value = false;
          return true;
        }
      });
      let test = ["address_1", "city", "country", "first_name", "last_name"];
      if (this.province.length) {
        test.push("state");
      }
      test.forEach(item => {
        if (!this.address[item]||this.address[item].trim() == "") {
          this.error[item] = [this.$t("account.field_required")];
          value = false;
        }
      });
      console.log("value", value);
      return value;
    },
    async setaddress() {
      if (this.yanzheng()) {
        try {
          this.loading = true;
          this.toadd = "";
          let res = await this.$axios.post(API.setaddress, this.address);
          if (res.status == 200) {
            window.open("/account/address", "_self");
          }
        } catch (error) {
          this.loading = false;
          this.toadd = "ADD ADDRESS";
          if (error.response.status == 422) {
            this.error = error.response.data.errors;
          } else {
            this.$message.error(error.response.statusText);
          }
        }
      }
    },
    async updateaddress() {
      if (this.yanzheng()) {
        try {
          this.loading = true;
          this.toupdate = "";
          let res = await this.$axios.put(
            API.updateaddress + this.address.id,
            this.address
          );
          if (res.status == 200) {
            window.open("/account/address", "_self");
          }
        } catch (error) {
          this.loading = false;
          this.toupdate = "UPDATE ADDRESS";
          if (error.response.status == 422) {
            console.log(error.response);

            this.error = error.response.data.errors;
          } else {
            this.$message.error(error.response.statusText);
          }
        }
      }
    }
  },
  beforeMount() {
    if (this.update) {
      let update = JSON.stringify(this.update);
      this.address = JSON.parse(update);
    }
    this.service.forEach(item => {
      if (item.code == this.address.country) {
        this.province = item.states;
      }
    });
    if (!this.update) {
      this.address.state = this.province.length ? this.province[0].code : "";
    }
  },
  watch: {
    "$store.state.country"(newV) {
      this.address.country = newV;
      this.service.forEach(item => {
        if (item.code == newV) {
          this.province = item.states;
        }
      });
    }
  }
};
</script>
<style scoped lang='scss'>
.addressform{
  .addressform_title{
    font-size: 24px;
    font-family: Roboto;
    font-weight: 500;
    color: #222A40;
    line-height: 42px;
  }
  .addressform_body{
    margin-top: 20px;
    .row{
      margin-top: 30px;
      .form_item_lable{
        font-size: 24px;
        font-family: Roboto;
        font-weight: 400;
        color: #222A40;
        line-height: 42px;
        margin-bottom: 20px;
      }
      .page_text_font{
        height: 52px;
        background: #FFFFFF;
        border: 1px solid #CCCCCC;
      }
      .error {
        font-size: 14px;
        color: #e32c2b;
      }
      input,select {
        width: 100%;
        padding: 8px 10px;
        background: #f7f7f7;
        border: none;
      }
    }
  }
  .addressform_default{
    margin-top: 34px;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    .setdefaultbox{
      vertical-align: middle;
      width: 24px;
      height: 24px;
    }
    .set_default{
      margin-left: 10px;
      font-size: 24px;
      font-family: Roboto;
      font-weight: 400;
      color: #222A40;
      line-height: 42px;
    }
  }
  .showtime_button{
    padding: 0;
    button {
      width: 240px;
      height: 52px;
      span{
        font-size: 24px;
        font-family: Roboto;
        font-weight: 500;
        color: #FFFFFF;
      }
    }
    a{
      margin-left: 30px;
      font-size: 20px;
      font-family: Roboto;
      font-weight: 400;
      text-decoration: underline;
      color: #222A40;
      line-height: 42px;
    }
  }
}
</style>